import { useContext } from "react"

import { ScreenSizeContext } from "shared/context/ScreenSizeContext"

export function useScreenSize() {
  return useContext(ScreenSizeContext)
}
